import React from "react";

export const WireNoteLoader = React.lazy(() => import("./wire-note"));
